import { formatTL } from '@/lib/format';

export interface ServiceRevenue {
  label: string;
  value: number;
}

const MONTHLY_BASE = [
  { month: 'Mar', gelir: 68000, gider: 31000 },
  { month: 'Nis', gelir: 94000, gider: 42000 },
  { month: 'May', gelir: 110000, gider: 48000 },
  { month: 'Haz', gelir: 132000, gider: 55000 },
  { month: 'Tem', gelir: 156000, gider: 62000 },
];

export function MonthlyChart({ augustCiro, augustGider }: { augustCiro: number; augustGider: number }) {
  const data = [...MONTHLY_BASE, { month: 'Ağu', gelir: augustCiro, gider: augustGider }];
  const max = Math.max(...data.map((d) => d.gelir)) || 1;

  return (
    <div>
      <div className="flex h-44 items-end gap-3">
        {data.map((d) => (
          <div key={d.month} className="flex flex-1 flex-col items-center justify-end gap-1">
            <div className="flex w-full items-end justify-center gap-1">
              <div
                className="w-1/2 max-w-[22px] rounded-t-sm bg-primary-500"
                style={{ height: `${Math.round((d.gelir / max) * 160)}px` }}
                title={`Gelir ${formatTL(d.gelir)}`}
              />
              <div
                className="w-1/2 max-w-[22px] rounded-t-sm bg-accent-500"
                style={{ height: `${Math.round((d.gider / max) * 160)}px` }}
                title={`Gider ${formatTL(d.gider)}`}
              />
            </div>
            <span className="text-[11px] font-semibold text-foreground-500">{d.month}</span>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center justify-center gap-5 text-xs text-foreground-500">
        <span className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-primary-500" /> Gelir
        </span>
        <span className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-sm bg-accent-500" /> Gider
        </span>
      </div>
    </div>
  );
}

export function ServiceChart({ data }: { data: ServiceRevenue[] }) {
  const max = Math.max(...data.map((d) => d.value)) || 1;
  return (
    <div className="space-y-3">
      {data.map((d) => (
        <div key={d.label} className="flex items-center gap-3">
          <span className="w-40 shrink-0 truncate text-xs font-semibold text-foreground-700">{d.label}</span>
          <div className="h-5 flex-1 overflow-hidden rounded-sm bg-background-100">
            <div
              className="flex h-full items-center rounded-sm bg-primary-500 pl-2"
              style={{ width: `${Math.max(6, Math.round((d.value / max) * 100))}%` }}
            >
              <span className="whitespace-nowrap text-[11px] font-bold text-white">{formatTL(d.value)}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function CollectionChart({ collected, open }: { collected: number; open: number }) {
  const total = collected + open || 1;
  const collectedPct = Math.round((collected / total) * 100);
  return (
    <div>
      <div className="flex h-6 w-full overflow-hidden rounded-full bg-amber-100">
        <div className="flex items-center justify-center bg-emerald-500" style={{ width: `${collectedPct}%` }}>
          {collectedPct > 20 && (
            <span className="text-[11px] font-bold text-white">{collectedPct}%</span>
          )}
        </div>
        <div className="flex flex-1 items-center justify-center bg-amber-400">
          {100 - collectedPct > 20 && (
            <span className="text-[11px] font-bold text-white">{100 - collectedPct}%</span>
          )}
        </div>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3">
        <div className="rounded-lg bg-emerald-50 p-3">
          <div className="text-xs font-semibold text-emerald-700">Tahsil Edilen</div>
          <div className="mt-1 font-heading text-lg font-bold text-emerald-700">{formatTL(collected)}</div>
        </div>
        <div className="rounded-lg bg-amber-50 p-3">
          <div className="text-xs font-semibold text-amber-700">Açık Alacak</div>
          <div className="mt-1 font-heading text-lg font-bold text-amber-700">{formatTL(open)}</div>
        </div>
      </div>
    </div>
  );
}